import AlertActionTypes from './alert-types'

export const startErrorAlert = data => ({
    type: AlertActionTypes.START_ERROR_ALERT_DISPLAY,
    payload: data,
})

export const finishErrorAlert = data => ({
    type: AlertActionTypes.FINISH_ERROR_ALERT_DISPLAY,
    payload: data,
})

export const startSuccessAlert = data => ({
    type: AlertActionTypes.START_SUCCESS_ALERT_DISPLAY,
    payload: data,
})

export const finishSuccessAlert = data => ({
    type: AlertActionTypes.FINISH_SUCCESS_ALERT_DISPLAY,
    payload: data,
})

export const startInfoAlert = data => ({
    type: AlertActionTypes.START_INFO_ALERT_DISPLAY,
    payload: data,
})

export const finishInfoAlert = data => ({
    type: AlertActionTypes.FINISH_INFO_ALERT_DISPLAY,
    payload: data,
})

export const startWarningAlert = data => ({
    type: AlertActionTypes.START_WARNING_ALERT_DISPLAY,
    payload: data,
})

export const finishWarningAlert = data => ({
    type: AlertActionTypes.FINISH_WARNING_ALERT_DISPLAY,
    payload: data,
})

export const fetchNotificationAlert = data => ({
    type: AlertActionTypes.FETCH_NOTIFICATION_ALERT_DISPLAY,
    payload: data,
})

export const startNotificationAlert = data => ({
    type: AlertActionTypes.START_NOTIFICATION_ALERT_DISPLAY,
    payload: data,
})

export const finishNotificationAlert = data => ({
    type: AlertActionTypes.FINISH_NOTIFICATION_ALERT_DISPLAY,
    payload: data,
})

// App notifications. /identity/notifications
export const startFetchAppNotifications = data => ({
    type: AlertActionTypes.START_FETCH_APP_NOTIFICATIONS,
    payload: data,
})
export const successFetchAppNotifications = data => ({
    type: AlertActionTypes.SUCCESS_FETCH_APP_NOTIFICATIONS,
    payload: data,
})
export const finishFetchAppNotifications = data => ({
    type: AlertActionTypes.FINISH_FETCH_APP_NOTIFICATIONS,
    payload: data,
})
export const failureFetchAppNotifications = data => ({
    type: AlertActionTypes.FAILURE_FETCH_APP_NOTIFICATIONS,
    payload: data,
})

export const startDeleteAppNotification = data => ({
    type: AlertActionTypes.START_DELETE_APP_NOTIFICATION,
    payload: data,
})
export const successDeleteAppNotification = data => ({
    type: AlertActionTypes.SUCCESS_DELETE_APP_NOTIFICATION,
    payload: data,
})
export const failureDeleteAppNotification = data => ({
    type: AlertActionTypes.FAILURE_DELETE_APP_NOTIFICATION,
    payload: data,
})
